import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import { Loading, OutsideClick } from "../../Components";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  branchWithuserFilter,
  CREATE_MULTI_CN_DELIVERY,
  GET_KEY_ACCOUNT_USER,
  GetLRForOperationManagementReport,
} from "../../../Utils/AllPagesQuriesAndMutations";
import "./OperationsManagement.scss";
import { BsChevronDown } from "react-icons/bs";
import { getBranchCode, getUserID } from "../../../CommonFunction/GetUserInfo";
import styled from "styled-components";
import LMSProcessColumn from "./LMSProcessColumn";
import { useDispatch } from "react-redux";
import { useModalContext } from "../../Components/Reactportal/ModalContext";
import { RiRefreshLine } from "react-icons/ri";
import { useSelector } from "react-redux";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";

let statusTab = [
  { name: "All" },
  { name: "Outgoing Pipeline" },
  { name: "Connection Pipeline" },
  { name: "Incoming Pipeline" },
];

let decideDestination = {
  Assingn_Pickup: ["Pickup_Assigned"],
  Pickup_Assigned: ["Pickup_Done", "Reached_at_CC"],
  Pickup_Done: ["Reached_at_CC"],
  Reached_at_CC: ["Connection_Booked"],
  Connection_Booked: ["Connection_Successfull"],
  Connection_Successfull: ["Received_At_Destination"],
  Received_At_Destination: ["Delivery_Assigned"],
  Delivery_Assigned: ["Delivery_Confirmation"],
  Delivery_Confirmation: [],
};

export function getTableKey(name) {
  let tableKey = "";
  switch (name) {
    case "Assingn_Pickup":
      tableKey = "Consignment_Note";
      break;
    case "Pickup_Assigned":
      tableKey = "Pickup_Memo";
      break;
    case "Pickup_Done":
      tableKey = "CN_Pickup_Updation";
      break;
    case "Reached_at_CC":
      tableKey = "Inward_Connection";
      break;
    case "Connection_Booked":
      tableKey = "Connection_Memo";
      break;
    case "Connection_Successfull":
      tableKey = "Connection_Memo_Updation";
      break;
    case "Received_At_Destination":
      tableKey = "Connection_Memo_Receive";
      break;
    case "Delivery_Assigned":
      tableKey = "Delivery_Memo";
      break;
    case "Delivery_Confirmation":
      tableKey = "LR_Delivery";
      break;
    default:
      tableKey = "";
  }
  return tableKey;
}

function countAllObjects(data) {
  let totalCount = 0;

  for (const key in data) {
    if (Array.isArray(data[key])) {
      totalCount += data[key].length;
    }
  }

  return totalCount;
}

const OperationsManagement = () => {
  const [Tab, SetTab] = useState("All");
  const [formdata, setFormData] = useState([]);
  const [BranchData, setBranchData] = useState([]);
  const [kemData, setKAMData] = useState([]);
  const [branchIdArr, setBranchIdArr] = useState([]);
  const [KAMIdArr, setKAMIdArr] = useState([]);
  const [dropdownToggle, setDropdowmToggle] = useState(false);
  const [triggerUseE, setTriggerUseE] = useState(false);
  const [KAMdropdownToggle, setKAMDropdowmToggle] = useState(false);
  const [SelectAllBranch, setSelectAllBranch] = useState(false);
  const [SelectAllKAM, setSelectAllKAM] = useState(false);
  const [MultiDragableIds, setMultiDragableIds] = useState([]);
  const [disableLRArr, setDisableLRArr] = useState([]);
  const [LRTotalCount, setLRTotalCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const scrollRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const { pushModal, clearModalStack, setCurrentTitle } = useModalContext();
  const dispatch = useDispatch();
  let Refetch = useSelector((store) => store.FormFieldData.refresh);
  const { data, loading, refetch } = useQuery(GetLRForOperationManagementReport, {
    variables: { type: Tab, KAMIds: KAMIdArr },
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true,
  });
  const [fetchBranchData, { data: branchData }] = useLazyQuery(branchWithuserFilter);
  const { data: KAMData } = useQuery(GET_KEY_ACCOUNT_USER);
  const [createMultiCNDelivery, { data: MultiCNdata }] = useMutation(CREATE_MULTI_CN_DELIVERY);

  // useEffect(() => {
  //   const current = scrollRef.current;
  //   if (!current) return;

  //   const handleScroll = () => setScrollTop(current.scrollTop);

  //   current.addEventListener('scroll', handleScroll);
  //   return () => current.removeEventListener('scroll', handleScroll);
  // }, []);

  // // Restore scroll position after render
  // useLayoutEffect(() => {
  //   if (scrollRef.current) {
  //     scrollRef.current.scrollTop = scrollTop;
  //   }
  // }, [Refetch]); // rerenders due to `someProp` won't reset scroll

  useEffect(() => {
    if (data?.getLRForOperationManagementReport) {
      const filteredData = Object.entries(data?.getLRForOperationManagementReport).reduce((acc, [key, value]) => {
        if (Array.isArray(value)) {
          acc[key] = value;
        }
        return acc;
      }, {});
      setFormData(filteredData);
      let count = countAllObjects(data?.getLRForOperationManagementReport);
      setLRTotalCount(count);
    }
  }, [data]);

  useEffect(() => {
    const getData = async () => {
      const res = await fetchBranchData();
      if (res?.data) {
        let BData = res.data?.SearchBranchAsPerUserRightWithCompanyId;
        setBranchData(BData);
        let ids = BData.map((e) => e?.Unique_Id);
        setBranchIdArr(ids);
        setSelectAllBranch(true);
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 500); // delay in ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchText]);

  useEffect(() => {
    if (KAMData) {
      setKAMData(KAMData?.UsersSearch);
    }
  }, [KAMData]);

  useEffect(() => {
    async function fetchUserID() {
      let info = await getUserID();
      let ids = kemData?.map((e) => e?._id);
      if (ids.includes(info)) {
        console.log(info, "infoinfo");
        setKAMIdArr((prev) => [...prev, info]);
        // setUserID(info);
      } else {
        setKAMIdArr(ids);
        setSelectAllKAM(true);
      }
    }
    fetchUserID();
  }, [kemData]);

  useEffect(() => {
    if (Tab && KAMIdArr) {
      refetch({ type: Tab, KAMIds: KAMIdArr, global_search: debouncedSearchText });
    }
  }, [Tab, KAMIdArr, debouncedSearchText]);

  useEffect(() => {
    if (branchIdArr) {
      if (SelectAllBranch) {
        if (branchIdArr.length !== BranchData.length) {
          setSelectAllBranch(false);
        } else {
          setSelectAllBranch(true);
        }
      }
      sessionStorage.setItem("UserSelectedBranch", JSON.stringify(branchIdArr));
      refetch({ type: Tab, KAMIds: KAMIdArr });
    }
  }, [branchIdArr]);

  useEffect(() => {
    return () => {
      sessionStorage.setItem("UserSelectedBranch", JSON.stringify({}));
    };
  }, []);

  let ParentPortalCloseFunction = useCallback(() => {
    clearModalStack();
    setCurrentTitle("Consignment_Note");
    pushModal("Consignment_Note");
    sessionStorage.setItem("UserSelectedBranch", JSON.stringify(branchIdArr));
    dispatch({ type: "CLEAR_COMPONENT_PROP" });
  }, [branchIdArr]);

  useEffect(() => {
    if (Refetch) {
      sessionStorage.setItem("UserSelectedBranch", JSON.stringify(branchIdArr));
      refetch({ type: Tab, KAMIds: KAMIdArr })
        .then(() => {
          setMultiDragableIds([]);
          setDisableLRArr([]);
          dispatch({ type: "Refetch", payload: false });
        })
        .catch((err) => {
          setMultiDragableIds([]);
          setDisableLRArr([]);
          dispatch({ type: "Refetch", payload: false });
        });
    }
  }, [Refetch]);

  const selectMultiIds = (id, columnHeader) => {
    setMultiDragableIds((prev) => {
      const updated = prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id];
      const selectedLR = formdata[columnHeader]?.filter((e) => e._id === id);

      if (updated.length && selectedLR?.length) {
        const disableLR = formdata[columnHeader]
          ?.filter((e) => {
            if (columnHeader == "Assingn_Pickup") {
              return e.Assign_Pickup_Data?._id !== selectedLR[0]?.Assign_Pickup_Data?._id;
            } else if (columnHeader == "Pickup_Assigned") {
              return e.Pickup_Memo_Data?._id !== selectedLR[0]?.Pickup_Memo_Data?._id;
            } else if (columnHeader == "Pickup_Done") {
              return e.Pickup_Memo_Data?.Drop_At_Data?._id !== selectedLR[0]?.Pickup_Memo_Data?.Drop_At_Data?._id;
            } else if (columnHeader == "Reached_at_CC") {
              return e.Inward_Data?.Received_At_Data?._id !== selectedLR[0]?.Inward_Data?.Received_At_Data?._id;
            } else if (columnHeader == "Received_At_Destination") {
              return (
                e.Connection_Memo_Data?.To_Connection_Center_Data?._id !==
                selectedLR[0]?.Connection_Memo_Data?.To_Connection_Center_Data?._id
              );
            } else if (columnHeader == "Delivery_Assigned") {
              return e?.LR_No ? false : true;
            }
          })
          .map((e) => e._id);
        setDisableLRArr(disableLR);
      } else {
        setDisableLRArr([]);
      }

      return updated;
    });
  };

  let dragDropFun = async (result) => {
    const { destination, source, type, draggableId } = result;
    if (!destination || (destination.droppableId === source.droppableId && destination.index === source.index)) {
      return;
    }
    if (
      (Tab === "Incoming Pipeline" && source.droppableId == "Connection_Booked") ||
      !decideDestination[source?.droppableId].includes(destination?.droppableId)
    ) {
      return;
    } else if (destination?.droppableId == "Delivery_Confirmation" && MultiDragableIds?.length > 1) {
      await createMultiCNDelivery({ variables: { cnIds: MultiDragableIds } })
        .then((res) => {
          console.log(res);
          dispatch({ type: "Refetch", payload: true });
        })
        .catch((err) => console.log(err));
    } else {
      let LRArr = formdata[source?.droppableId];
      let dragableLRData;
      if (MultiDragableIds?.length > 0 && MultiDragableIds.includes(draggableId)) {
        dragableLRData = LRArr?.filter((e) => MultiDragableIds.includes(e._id));
      } else {
        dragableLRData = LRArr?.filter((e) => e._id == draggableId);
      }
      // console.log(dragableLRData, "dragableLRDatadragableLRData");
      let LrDetailObj = {
        LR_Data: dragableLRData?.map((e) => {
          let obj = {
            _id: e?._id,
            Date: e?.Date,
            LR_No: e?.LR_No,
            To_City: e?.To_City,
            Consignor: e?.Consignor,
            Consignee: e?.Consignee,
            Service_Type: e?.Service_Type_Data?.Service_Type_Name,
            Total_Number_Of_Boxes: e?.Total_Number_Of_Boxes,
            Total_Weight: e?.Total_Weight,
            Key_Account_Manager: e?.Key_Account_Manager,
            Branch_Code_Data: e?.Branch_Code_Data,
            Assign_Pickup_Data: e?.Assign_Pickup_Data,
          };
          return obj;
        }),
        PickupMemo_Data: dragableLRData[0]?.Pickup_Memo_Data,
        Inward_Data: dragableLRData[0]?.Inward_Data,
        pickup_Updation_Data: dragableLRData[0]?.pickup_Updation_Data,
        Connection_Memo_Data: dragableLRData[0]?.Connection_Memo_Data?.[0] || null,
        Connection_Updation_Data: dragableLRData[0]?.Connection_Updation_Data?.[0] || null,
        connection_Receive_Data: dragableLRData[0]?.connection_Receive_Data?.[0] || null,
      };

      if (type == "task") {
        let tablekey = getTableKey(destination?.droppableId);
        dispatch({ type: "CLEAR_ALL_COMPONENT_PROP" });
        clearModalStack();
        setCurrentTitle(tablekey);
        pushModal(tablekey);
        // console.log(LrDetailObj, tablekey, "LrDetailObj");
        dispatch({
          type: "SET_COMPONENT_PROP",
          payload: {
            Table_Key: tablekey,
            props: {
              show: true,
              ParentPortalCloseFunction,
              TypeOfPortal: "Add",
              submitType: "",
              openByCard: true,
              FormDetailsByCard: LrDetailObj,
            },
          },
        });
      }
    }
  };

  const toggleBranchId = (branchId) => {
    setBranchIdArr((prev) => (prev.includes(branchId) ? prev.filter((id) => id !== branchId) : [...prev, branchId]));
  };

  const toggleKAMId = (branchId) => {
    setKAMIdArr((prev) => (prev.includes(branchId) ? prev.filter((id) => id !== branchId) : [...prev, branchId]));
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "95vh" }}>
      <div>
        <HeaderDiv title={"Operations Management"} TableKey={"Consignment_Note"} MoreActions={{ Is_Print: false }} />
        <div className="tabdiv">
          <div style={{ display: "flex", alignItems: "center", gap: "50px" }}>
            <Tabs tabs={statusTab} SetTabPage={SetTab} />
            <div style={{ fontWeight: "bold" }}>Total LR : {LRTotalCount} </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "25px" }}>
            <div>
              <input
                type="text"
                placeholder="Search LR"
                className="SearchInputInops"
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            <div>
              <div
                className="CheckInput"
                onClick={() => {
                  setKAMDropdowmToggle(true);
                }}
              >
                <span>Key Account Manager</span>
                <BsChevronDown type="button" className={"icondown"} />
              </div>
              {KAMdropdownToggle && (
                <OutsideClick setToggled={() => setKAMDropdowmToggle(false)}>
                  <div className="branchDD">
                    {kemData && kemData.length > 0 && (
                      <div>
                        <input
                          type="checkbox"
                          name=""
                          checked={SelectAllKAM}
                          id=""
                          onChange={(el) => {
                            if (el.target.checked) {
                              let ids = kemData.map((e) => e?._id);
                              setKAMIdArr(ids);
                              setSelectAllKAM(el.target.checked);
                            } else {
                              setKAMIdArr([]);
                              setSelectAllKAM(el.target.checked);
                            }
                          }}
                        />
                        <div>Select All</div>
                      </div>
                    )}

                    {kemData &&
                      kemData.length > 0 &&
                      kemData.map((e) => (
                        <div>
                          <input
                            type="checkbox"
                            name=""
                            checked={KAMIdArr?.includes(e?._id)}
                            id=""
                            onChange={(el) => toggleKAMId(e?._id)}
                          />
                          <div>{e?.Full_Name || ""}</div>
                        </div>
                      ))}
                  </div>
                </OutsideClick>
              )}
            </div>
            <div>
              <div
                className="CheckInput"
                onClick={() => {
                  setDropdowmToggle(true);
                }}
              >
                <span>Select Branch</span>
                <BsChevronDown type="button" className={"icondown"} onClick={() => {}} />
              </div>
              {dropdownToggle && (
                <OutsideClick setToggled={() => setDropdowmToggle(false)}>
                  <div className="branchDD">
                    {BranchData && BranchData.length > 0 && (
                      <div>
                        <input
                          type="checkbox"
                          name=""
                          checked={SelectAllBranch}
                          id=""
                          onChange={(el) => {
                            if (el.target.checked) {
                              let ids = BranchData.map((e) => e?.Unique_Id);
                              setBranchIdArr(ids);
                              setSelectAllBranch(el.target.checked);
                            } else {
                              setBranchIdArr([]);
                              setSelectAllBranch(el.target.checked);
                            }
                          }}
                        />
                        <div>Select All</div>
                      </div>
                    )}

                    {BranchData &&
                      BranchData.length > 0 &&
                      BranchData.map((e) => (
                        <div>
                          <input
                            type="checkbox"
                            name=""
                            checked={branchIdArr?.includes(e?.Unique_Id)}
                            id=""
                            onChange={(el) => toggleBranchId(e?.Unique_Id)}
                          />
                          <div>{e?.Name || ""}</div>
                        </div>
                      ))}
                  </div>
                </OutsideClick>
              )}
            </div>
          </div>
        </div>
      </div>
      <div style={{ flex: 1 }} ref={scrollRef}>
        {loading ? (
          <Loading />
        ) : (
          <BoardContainer>
            <DragDropContext onDragEnd={dragDropFun}>
              <Droppable droppableId="all-columns" direction="horizontal" type="column">
                {(provided) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      flex: 1,
                    }}
                  >
                    {Object.keys(formdata)?.map((columnHeader, index) => {
                      const isColumnCollapsed = columnHeader?.Is_Collapsed;
                      const taskColumn = columnHeader?._id;
                      // console.log(columnHeader, "columnHeader");

                      return (
                        <Draggable key={columnHeader} draggableId={""} index={index}>
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={{
                                userSelect: "none",
                                padding: "2px",
                                margin: "0 8px",
                                // marginTop: "10px",
                                height: "80vh",
                                minWidth: isColumnCollapsed ? "150px" : "250px", // Collapse width
                                background: isColumnCollapsed ? "transparent" : "#ebecf0", // Transparent when collapsed
                                display: "flex",
                                flexDirection: "column",
                                borderRadius: "5px",
                                [snapshot.isDragging ? "rotate" : "trasform"]: snapshot.isDragging ? "10deg" : null,
                                ...provided.draggableProps.style,
                              }}
                            >
                              <LMSProcessColumn
                                columnHeader={columnHeader}
                                formdata={formdata}
                                selectMultiIds={(id, columnHeader) => selectMultiIds(id, columnHeader)}
                                MultiDragableIds={MultiDragableIds}
                                disableLRArr={disableLRArr}
                              />
                            </div>
                          )}
                        </Draggable>
                      );
                    })}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </BoardContainer>
        )}
      </div>
    </div>
  );
};

export default OperationsManagement;

const BoardContainer = styled.div`
  display: flex;
  overflow-x: auto;
  height: 100%; // Ensure this matches your layout requirements
`;
